import { axios, AxiosResponse } from "@sdk/axios";
import type { PaginatedOptions, PaginatedResults } from "@sdk/utils/paginated-results";

export async function postAccountingListReport<Row>(
  config: { basePath: string; token: string },
  path: string,
  req: { query: Record<string, unknown>; options?: PaginatedOptions }
): Promise<PaginatedResults<Row>> {
  const results: AxiosResponse<PaginatedResults<Row>> = await axios.post(
    `${config.basePath}/${path}/report`,
    req,
    { headers: { Authorization: config.token } }
  );
  return results.data;
}
